const SERVER_URL = config.serverUrl;
const GROUP_ALIAS = config.groupAlias;
const DRIVE_APP_NAME = config.driveAppName;
const DRIVEWORKS_LIVE_CLIENT_CONFIG = config.DriveWorksLiveClientConfig;

function loadDriveWorksClient() {
    revealConfigurator();

    const script = document.createElement("script");
    script.src = SERVER_URL + "/DriveWorksLiveIntegrationClient.min.js";
    script.onload = () => driveWorksClientLoaded();
    document.body.appendChild(script);
    console.log("%cLoading DriveWorks Live client 2...", "color: orange;");
};

/**
 * Reveal the configurator on gated pages.
 *
 * PHP prints the .driveworks-box hidden when the page requires the customer
 * gate, so the loading spinner is not visible behind the form. It is shown here
 * rather than in gate.js so that it appears at the moment DriveWorks actually
 * starts loading - and so the configurator still works if the gate script is
 * ever unavailable. Ungated pages have no [data-dw-gated] box and are ignored.
 */
function revealConfigurator() {
    const box = document.querySelector(".driveworks-box[data-dw-gated]");

    if (box) {
        box.hidden = false;
    }
}

async function driveWorksClientLoaded() {
    await processSession();

    startClientFunctions();
    
}

async function processSession() {
    try {
        const existingSessionId = localStorage.getItem("sessionId");

        // Create client
        DW_CLIENT = new window.DriveWorksLiveClient(SERVER_URL, DRIVEWORKS_LIVE_CLIENT_CONFIG);

        // No existing session found, create new.
        if (!existingSessionId) {
            console.log("%cNo session found, creating new...", "color: orange;");

            await loginGroup();
            return;
        }

        // Check existing session is valid.
        const isValidSession = await validateExistingSession(existingSessionId);

        // Valid session, re-use.
        if (isValidSession) {
            console.log("%cExisting session found, restoring...", "color: orange;", existingSessionId);
            return;
        }

        // Invalid session id, create new.
        console.log("%cInvalid session found, creating new...", "color: red;");
        await loginGroup();

    } catch(error) {
        console.log(error);
    }
}

async function validateExistingSession(existingSessionId) {
    DW_CLIENT._sessionId = existingSessionId;

    try {
        await DW_CLIENT.getDriveApps(GROUP_ALIAS, "$top=0");
        return true;
    } catch (error) {
        console.log(error);
        return false;
    }
}

async function loginGroup() {
    try {
        const session = await DW_CLIENT.loginGroup(GROUP_ALIAS);

        localStorage.setItem("sessionId", session.sessionId);
    } catch(error) {
        console.log(error);
    }
}

async function setTeamId(specification) {
    const storedTeam = "Web";
    console.log("%cSET TEAM ID", "color: royalblue;");
    await setConstant(specification, "Team", storedTeam);
    localStorage.setItem("teamId", storedTeam);
}

/**
 * Send the customer details captured by the website gate form into CPQ, as a
 * JSON string in the config.formDataConstant constant.
 *
 * Every key is always sent, as text. The internal /catalog/ flow is not gated,
 * so there it is sent with every value empty. setConstant() skips a constant
 * DriveWorks has not created yet, so this is safe to call before it exists.
 *
 * Set once, before the Specification is rendered, so anything the visitor edits
 * inside DriveWorks is never overwritten.
 *
 * Called from Basket.js only, because the Request a Quote form lives in the
 * basket. Each page runs its own Specification, so setting this on the product
 * page would cost extra DriveWorks requests with no confirmed effect on the
 * quote. If DriveWorks confirm it must be set on the item Specification too,
 * add a call in product.js after runDriveApp.
 */
async function setFormDataConstant(specification) {
    const constantName = config.formDataConstant;

    if (!constantName) {
        return;
    }

    const customer = (window.DWGate && window.DWGate.getCustomer()) || {};
    const text = value => (value === undefined || value === null ? "" : String(value));

    // Keys listed one by one on purpose - the customer record also holds the
    // entry write token, which must never leave the website.
    const formData = {
        entryId: text(customer.entryId),
        firstName: text(customer.firstName),
        lastName: text(customer.lastName),
        phone: text(customer.phone),
        email: text(customer.email),
        customerType: text(customer.customerType),
        companyName: text(customer.companyName),

        // Campaign tracking captured with the form - see $tracking_map in
        // includes/driveworks-gate.php. Empty for visitors who arrived without
        // any, and always empty for the internal /catalog/ flow.
        gclid: text(customer.gclid),
        msclkid: text(customer.msclkid),
        fbclid: text(customer.fbclid),
        utm_source: text(customer.utm_source),
        utm_medium: text(customer.utm_medium),
        utm_campaign: text(customer.utm_campaign),
        utm_term: text(customer.utm_term),
        utm_content: text(customer.utm_content),
    };

    console.log("%cSET WORDPRESS FORM DATA", "color: violet;");
    console.log (formData);
    await setConstant(specification, constantName, JSON.stringify(formData));
}

/**
 * List every constant and variable on the running Specification.
 *
 * Integration aid: the CPQ constant names are not documented anywhere on our
 * side, so this dumps them from the live Specification. Run dwListConstants()
 * in the browser console on the basket page, e.g. to check that
 * config.formDataConstant exists.
 *
 * Pass a search term to narrow it down, e.g. dwListConstants("name").
 */
async function dwListConstants(filter) {
    const specification = window.DW_SPECIFICATION;

    if (!specification) {
        console.log("No Specification running yet - wait for the configurator to load.");
        return;
    }

    const matches = value => !filter || String(value).toLowerCase().includes(String(filter).toLowerCase());

    try {
        const [constants, variables] = await Promise.all([
            specification.getConstants(),
            specification.getVariables(),
        ]);

        console.log("%cCONSTANTS (settable)", "color: violet; font-weight: bold;");
        console.table(constants.filter(item => matches(item.name)).map(item => ({ name: item.name, value: item.value })));

        console.log("%cVARIABLES (read only)", "color: violet; font-weight: bold;");
        console.table(variables.filter(item => matches(item.name)).map(item => ({ name: item.name, value: item.value })));

        return { constants: constants, variables: variables };
    } catch (error) {
        console.log(error);
    }
}

/**
 * Attach this page's Specification to the visitor's order.
 *
 * Restores the order the visitor already has, or creates one when this is the
 * first configurator page they reach - which on a gated page is moments after
 * the gate form is submitted, because that is when DriveWorks is first started.
 *
 * Run before render, so the order exists and carries the customer details by
 * the time the configurator appears.
 *
 * @param specification         The running Specification.
 * @param options.createOrder   Create the order when the visitor does not have
 *                              one yet. Product pages only - catalog pages must
 *                              not create orders, because J&E browse the
 *                              internal catalog without ever filling in the gate
 *                              form, which would leave empty orders behind.
 */
async function setOrderId(specification, options = {}) {
    const orderId = localStorage.getItem("orderId");

    // EXISTING ORDER: Restore stored id.
    if (orderId) {
        console.log("Existing order id:", orderId);

        await setConstant(specification, "ParameterOrderId", orderId);
        return;
    }

    // NEW ORDER: Set order name to retrieve order id.
    console.log("New order");
    await setConstant(specification, "OrderName", `DW-${specification.id}`);
    localStorage.setItem("orderName", `DW-${specification.id}`);

    // Catalog pages stop here - the order is created on a product page.
    if (options.createOrder !== true) {
        console.log("%cOrder not created on this page", "color: orange;");

        return;
    }

    // The gate form details go in BEFORE the order is created, so DriveWorks
    // has them when CreateOrder runs.
    await setFormDataConstant(specification);
    await console.log("%cGate Form Details were set to the constant ProjectData", "color: violet; font-weight: bold;");
    await runMacro(specification, "CreateOrder", "");
    await console.log("%cCreateOrder Macro Run, so order should be created", "color: red; font-weight: bold;");
    // Read the new id straight away rather than waiting for DriveWorks to push
    // it, so the next page sees an existing order and does not create a second
    // one - this is what keeps CreateOrder to once per order.
    await ensureOrderId();
}

/**
 * Make sure the order id is stored before leaving the page for the basket.
 *
 * The id normally arrives as a ParameterOrderId change pushed over the
 * DriveWorks WebSocket, but that push and the redirect that follows adding an
 * item are separate events. When the redirect wins the race - or the browser
 * cuts the socket as the page navigates, which Firefox does - the basket loads
 * with no order id and shows as empty. Reading the constant directly removes
 * the race.
 *
 * Does nothing when the id is already stored, so the usual path costs no extra
 * DriveWorks request.
 */
async function ensureOrderId() {
    if (localStorage.getItem("orderId")) {
        return;
    }

    console.log("%cNo order id stored yet, reading it before redirect...", "color: orange;");

    const constant = await getConstant(window.DW_SPECIFICATION, "ParameterOrderId");

    if (constant && constant.value) {
        localStorage.setItem("orderId", constant.value);
    }
}

async function getConstant(specification, constantName) {
    try {
        const constant = await specification.getConstantByName(constantName);
        console.log(`Get Constant: ${constantName} - ${constant.value}`);

        return constant;
    } catch(error) {
        console.log(error);
    }
}

async function setConstant(specification, constantName, constantValue) {
    try {
        await specification.getConstantByName(constantName);
        await specification.updateConstantValue(constantName, constantValue);

        console.log(`Set Constant: ${constantName} - ${constantValue}`);
    } catch(error) {
        console.log(error);
    }
}

async function getVariable(specification, variableName) {
    try {
        const variable = await specification.getVariableByName(variableName);
        console.log(`Get Variable: ${variableName} - ${variable.value}`);

        return variable;
    } catch(error) {
        console.log(error);
    }
}

async function runMacro(specification, macroName, macroArgument) {
    try {
        await specification.runMacro({
            "macroName": macroName,
            "macroArgument": macroArgument,
        });

        console.log(`Run Macro: ${macroName} - ${macroArgument}`);
    } catch(error) {
        console.log(error);
    }
}

/**
 * Prevent Specification timeout
 * 
 * A Specification will timeout after a configured period of inactivity (see DriveWorksConfigUser.xml).
 * This function prevents a Specification timing out as long as the page is in view.
 * 
 * @param specification The Specification object.
 */
function pingSpecification(specification) {

    // Disable ping if interval is 0
    if (config.specificationPingInterval === 0) {
        return;
    }

    // Ping Specification to reset timeout
    specification.ping();

    // Schedule next ping
    setTimeout(pingSpecification, config.specificationPingInterval * 1000, specification);
}
